import { CheckboxStyle } from "./Checkbox/checkboxStyle";
import { FileUploadStyle } from "./FileUpload/fileUploadStyle";
import { GoalStyle } from "./GoalExample/goalStyle";
import { ImageMuiStyle } from "./Image/imageMuiStyle";
import { RadioStyle } from "./Radio/radioStyle";
import { SelectMuiStyle } from "./Select/selectMuiStyle";
import { tableStyle } from "./Table/tableStyle";

export const STYLE_MUI = `
    * { box-sizing: border-box; } body {margin: 0;}.list-version .item-version .item-version-text{margin-left:15px;}.list-version .item-version{display:flex;cursor:pointer;}.gjs-cell{width:8%;display:table-cell;height:75px;}.gjs-row{display:table;padding-top:10px;padding-right:10px;padding-bottom:10px;padding-left:10px;width:100%;}#itr4{padding:10px;}#id2a{font-family:Montserrat-Bold;font-size:23.2px;font-weight:700;letter-spacing:0.217616px;}#i06mt{font-weight:700;letter-spacing:0.217616px;font-size:15.66px;position:relative;line-height:0;vertical-align:initial;top:-0.5em;font-family:Poppins-Regular;color:red;}#izkj{border-radius:10px;background-color:#fff;margin:0 0 10px 0;}#ilzky{width:30%;height:10px;}#iyudi{padding:10px;}#ii9as{font-family:Poppins-Regular;font-size:18.4px;font-weight:700;letter-spacing:0.172592px;}#ijggb{font-family:Poppins-Regular;font-weight:700;letter-spacing:0.172592px;font-size:12.42px;position:relative;line-height:0;vertical-align:initial;top:-0.5em;color:red;}#i49kd{width:70%;height:20px;}#t9b6aIHYdTLTl9D{width:70%;}#iloyo{width:100%;padding:10px 10px 0 0;}#ilqe{background-color:#e5e5e5;}#ifmlt{width:30%;height:10px;}#im0u4{padding:10px;}#im14d{margin:0px 10px 0px 0px;font-size:1.15rem;font-family:Poppins-Regular;font-weight:700;line-height:1.5;letter-spacing:0.00938em;}#i1i5s{font-size:12.42px;position:relative;line-height:0;vertical-align:initial;top:-0.5em;color:red;}#iawtg{width:70%;height:10px;}#i5gu3{padding:0 10px 0 0;}#ij9qe{width:80%;display:block;}#i5v9v{border-radius:10px;background-color:#fff;margin:0 0 10px 0;}#ijzya{padding:10px;}#iemqf{font-family:Montserrat-Bold;font-size:20.88px;font-weight:700;letter-spacing:0.195854px;}#iweve{padding:10px;}#ibznr{font-family:Poppins-Regular;font-size:18.72px;font-weight:700;letter-spacing:0.175594px;}#i56yk{font-size:14.04px;position:relative;line-height:0;vertical-align:initial;top:-0.5em;font-family:Poppins-Regular;font-weight:700;letter-spacing:0.175594px;color:red;}#igqm1{padding:10px;width:70%;}#icvjc{padding:10px;}#iju43{font-family:Poppins-Regular;font-size:20.8px;font-weight:700;letter-spacing:0.195104px;}#iadv1{padding:10px;width:70%;}#i9fco{font-family:Poppins-Regular;font-size:17.6px;letter-spacing:0.165088px;}#ipvd6{width:80%;display:block;}#ily72{padding:10px;}#i67hf{font-family:Poppins-Regular;font-size:20.8px;font-weight:700;letter-spacing:0.195104px;}#ikhrq{padding:10px;width:70%;}#ivwud{font-family:Poppins-Regular;font-size:17.6px;letter-spacing:0.165088px;}#ii9mx{width:80%;display:block;}#iawig{padding:10px;}#ipkmu{font-family:Poppins-Regular;font-size:18.72px;font-weight:700;letter-spacing:0.175594px;}#ihhzy{padding:10px;width:70%;}#i6tjj{font-family:Poppins-Regular;font-size:17.6px;letter-spacing:0.165088px;}#i67b3{display:block;width:80%;}#iyd6p{padding:10px;}#i5b1v{font-family:Poppins-Regular;font-size:18.72px;font-weight:700;letter-spacing:0.175594px;}#iyls7{padding:10px;width:70%;}#ijvud{font-family:Poppins-Regular;font-size:17.6px;letter-spacing:0.165088px;}#ize4g{width:80%;display:block;}#i6g08{padding:10px;}#iakkw{font-family:Poppins-Regular;font-size:18.72px;font-weight:700;letter-spacing:0.175594px;}#iz9fl{padding:10px;width:70%;}#ippf4{font-family:Poppins-Regular;font-size:17.6px;letter-spacing:0.165088px;}#iydo4k{width:80%;display:block;}#ispvp6{padding:10px;}#iqbz3t{font-family:Poppins-Regular;font-size:20.8px;font-weight:700;letter-spacing:0.195104px;}#i66ndw{padding:10px;width:70%;}#ibvjva{font-family:Poppins-Regular;font-size:17.6px;letter-spacing:0.165088px;}#i32uhl{display:block;width:80%;}#i28fje{padding:10px;}#ilwqwc{font-family:Poppins-Regular;font-size:20.8px;font-weight:700;letter-spacing:0.195104px;}#idfw1i{padding:10px;width:70%;}#iue00f{font-family:Poppins-Regular;font-size:17.6px;letter-spacing:0.165088px;}#i7zs9q{display:block;width:80%;}#imuva8{padding:10px;}#iehjty{font-family:Poppins-Regular;font-size:20.8px;font-weight:700;letter-spacing:0.195104px;}#iedmii{padding:10px;width:70%;}#imizth{font-family:Poppins-Regular;font-size:17.6px;letter-spacing:0.165088px;}#ijklqr{width:80%;}#iown1n{padding:10px;}#im128t{font-family:Poppins-Regular;font-size:20.8px;font-weight:700;letter-spacing:0.195104px;}#i3qlqo{padding:10px;width:70%;}#i2x8hi{font-family:Poppins-Regular;font-size:17.6px;letter-spacing:0.165088px;}#ixsoy5{display:block;width:80%;}#ir9kt8{background-color:#fff;border-radius:10px;margin:0 0 10px 0;}#i3ptyf{padding:10px;}#ikitgj{font-family:Poppins-Regular;font-size:23.2px;font-weight:700;letter-spacing:0.217616px;background-color:rgb(255, 255, 255);}#ixd627{padding:0 15px 0 15px;}#iz0xuw{padding:0 0 0 15px;}#BGcXgcZ3ICAv21d-2{padding:0 0 0 15px;}#itrezs{padding:0 15px 0 15px;}#ia69k2{border-radius:10px;background-color:#fff;}#idlwng{padding:10px;margin:0 0 10px 0;}#iirgaj{font-family:Poppins-Regular;font-size:23.2px;font-weight:700;letter-spacing:0.217616px;}#i1gne{padding:10px 0 10px 0;}#ir3xk{top:16px;position:relative;left:0;}#i9qdk{padding:0 0 0 10px;}#iofua{padding:0 0 0 10px;}#i2dat{padding:10px 0 10px 10px;}@media (max-width: 768px){.gjs-cell{width:100%;display:block;}}

    @-webkit-keyframes mui-auto-fill {}

    @-webkit-keyframes mui-auto-fill-cancel {}

    .MuiInputBase-root {
    color: rgba(0, 0, 0, 0.87);
    cursor: text;
    display: inline-flex;
    position: relative;
    font-size: 1rem;
    box-sizing: border-box;
    align-items: center;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    line-height: 1.1876em;
    letter-spacing: 0.00938em;
    }

    .MuiInputBase-root.Mui-disabled {
    color: rgba(0, 0, 0, 0.38);
    cursor: default;
    }

    .MuiInputBase-multiline {
    padding: 6px 0 7px;
    }

    .MuiInputBase-multiline.MuiInputBase-marginDense {
    padding-top: 3px;
    }

    .MuiInputBase-fullWidth {
    width: 100%;
    }

    .MuiInputBase-input {
    font: inherit;
    color: currentColor;
    width: 100%;
    border: 0;
    height: 1.1876em;
    margin: 0;
    display: block;
    padding: 6px 0 7px;
    min-width: 0;
    background: none;
    box-sizing: content-box;
    animation-name: mui-auto-fill-cancel;
    letter-spacing: inherit;
    animation-duration: 10ms;
    -webkit-tap-highlight-color: transparent;
    }

    .MuiInputBase-input::-webkit-input-placeholder {
    color: currentColor;
    opacity: 0.42;
    transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    }

    .MuiInputBase-input::-moz-placeholder {
    color: currentColor;
    opacity: 0.42;
    transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    }

    .MuiInputBase-input:-ms-input-placeholder {
    color: currentColor;
    opacity: 0.42;
    transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    }

    .MuiInputBase-input::-ms-input-placeholder {
    color: currentColor;
    opacity: 0.42;
    transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    }

    .MuiInputBase-input:focus {
    outline: 0;
    }

    .MuiInputBase-input:invalid {
    box-shadow: none;
    }

    .MuiInputBase-input::-webkit-search-decoration {
    -webkit-appearance: none;
    }

    .MuiInputBase-input.Mui-disabled {
    opacity: 1;
    }

    .MuiInputBase-input:-webkit-autofill {
    animation-name: mui-auto-fill;
    animation-duration: 5000s;
    }

    label[data-shrink=false]+.MuiInputBase-formControl .MuiInputBase-input::-webkit-input-placeholder {
    opacity: 0 !important;
    }

    label[data-shrink=false]+.MuiInputBase-formControl .MuiInputBase-input::-moz-placeholder {
    opacity: 0 !important;
    }

    label[data-shrink=false]+.MuiInputBase-formControl .MuiInputBase-input:-ms-input-placeholder {
    opacity: 0 !important;
    }

    label[data-shrink=false]+.MuiInputBase-formControl .MuiInputBase-input::-ms-input-placeholder {
    opacity: 0 !important;
    }

    label[data-shrink=false]+.MuiInputBase-formControl .MuiInputBase-input:focus::-webkit-input-placeholder {
    opacity: 0.42;
    }

    label[data-shrink=false]+.MuiInputBase-formControl .MuiInputBase-input:focus::-moz-placeholder {
    opacity: 0.42;
    }

    label[data-shrink=false]+.MuiInputBase-formControl .MuiInputBase-input:focus:-ms-input-placeholder {
    opacity: 0.42;
    }

    label[data-shrink=false]+.MuiInputBase-formControl .MuiInputBase-input:focus::-ms-input-placeholder {
    opacity: 0.42;
    }

    .MuiInputBase-inputMarginDense {
    padding-top: 3px;
    }

    .MuiInputBase-inputMultiline {
    height: auto;
    resize: none;
    padding: 0;
    }

    .MuiInputBase-inputTypeSearch {
    -moz-appearance: textfield;
    -webkit-appearance: textfield;
    }

    .MuiFormControl-root {
    border: 0;
    margin: 0;
    display: inline-flex;
    padding: 0;
    position: relative;
    min-width: 0;
    flex-direction: column;
    vertical-align: top;
    }

    .MuiFormControl-marginNormal {
    margin-bottom: 8px;
    }

    .MuiFormControl-marginDense {
    margin-top: 8px;
    margin-bottom: 4px;
    }

    .MuiFormControl-fullWidth {
    width: 100%;
    }

    .MuiFormLabel-root {
    color: rgba(0, 0, 0, 0.54);
    padding: 0;
    font-size: 1rem;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    line-height: 1;
    letter-spacing: 0.00938em;
    }

    .MuiFormLabel-root.Mui-focused {
    color: #3f51b5;
    }

    .MuiFormLabel-root.Mui-disabled {
    color: rgba(0, 0, 0, 0.38);
    }

    .MuiFormLabel-root.Mui-error {
    color: #f44336;
    }

    .MuiFormLabel-colorSecondary.Mui-focused {
    color: #f50057;
    }

    .MuiFormLabel-asterisk.Mui-error {
    color: #f44336;
    }

    .MuiInputLabel-root {
    display: block;
    transform-origin: top left;
    }

    .MuiInputLabel-formControl {
    top: 0;
    left: 0;
    position: absolute;
    transform: translate(0, 24px) scale(1);
    }

    .MuiInputLabel-marginDense {
    transform: translate(0, 21px) scale(1);
    }

    .MuiInputLabel-shrink {
    transform: translate(0, 1.5px) scale(0.75);
    transform-origin: top left;
    }

    .MuiInputLabel-animated {
    transition: color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
    }

    .MuiInputLabel-filled {
    z-index: 1;
    transform: translate(12px, 20px) scale(1);
    pointer-events: none;
    }

    .MuiInputLabel-filled.MuiInputLabel-marginDense {
    transform: translate(12px, 17px) scale(1);
    }

    .MuiInputLabel-filled.MuiInputLabel-shrink {
    transform: translate(12px, 10px) scale(0.75);
    }

    .MuiInputLabel-filled.MuiInputLabel-shrink.MuiInputLabel-marginDense {
    transform: translate(12px, 7px) scale(0.75);
    }

    .MuiInputLabel-outlined {
    z-index: 1;
    transform: translate(14px, 20px) scale(1);
    pointer-events: none;
    }

    .MuiInputLabel-outlined.MuiInputLabel-marginDense {
    transform: translate(14px, 12px) scale(1);
    }

    .MuiInputLabel-outlined.MuiInputLabel-shrink {
    transform: translate(14px, -6px) scale(0.75);
    }

    .PrivateNotchedOutline-root-1 {
    top: -5px;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    padding: 0 8px;
    overflow: hidden;
    position: absolute;
    border-style: solid;
    border-width: 1px;
    border-radius: inherit;
    pointer-events: none;
    }

    .PrivateNotchedOutline-legend-2 {
    padding: 0;
    text-align: left;
    transition: width 150ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
    line-height: 11px;
    }

    .PrivateNotchedOutline-legendLabelled-3 {
    width: auto;
    height: 11px;
    display: block;
    padding: 0;
    font-size: 0.75em;
    max-width: 0.01px;
    text-align: left;
    transition: max-width 50ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
    visibility: hidden;
    }

    .PrivateNotchedOutline-legendLabelled-3 &gt;

    span {
    display: inline-block;
    padding-left: 5px;
    padding-right: 5px;
    }

    .PrivateNotchedOutline-legendNotched-4 {
    max-width: 1000px;
    transition: max-width 100ms cubic-bezier(0.0, 0, 0.2, 1) 50ms;
    }

    .MuiOutlinedInput-root {
    position: relative;
    border-radius: 4px;
    }

    .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: rgba(0, 0, 0, 0.87);
    }

    @media (hover: none) {
    .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: rgba(0, 0, 0, 0.23);
    }
    }

    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #3f51b5;
    border-width: 2px;
    }

    .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {
    border-color: #f44336;
    }

    .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {
    border-color: rgba(0, 0, 0, 0.26);
    }

    .MuiOutlinedInput-colorSecondary.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #f50057;
    }

    .MuiOutlinedInput-adornedStart {
    padding-left: 14px;
    }

    .MuiOutlinedInput-adornedEnd {
    padding-right: 14px;
    }

    .MuiOutlinedInput-multiline {
    padding: 18.5px 14px;
    }

    .MuiOutlinedInput-multiline.MuiOutlinedInput-marginDense {
    padding-top: 10.5px;
    padding-bottom: 10.5px;
    }

    .MuiOutlinedInput-notchedOutline {
    border-color: rgba(0, 0, 0, 0.23);
    }

    .MuiOutlinedInput-input {
    padding: 18.5px 14px;
    }

    .MuiOutlinedInput-input:-webkit-autofill {
    border-radius: inherit;
    }

    .MuiOutlinedInput-inputMarginDense {
    padding-top: 10.5px;
    padding-bottom: 10.5px;
    }

    .MuiOutlinedInput-inputMultiline {
    padding: 0;
    }

    .MuiOutlinedInput-inputAdornedStart {
    padding-left: 0;
    }

    .MuiOutlinedInput-inputAdornedEnd {
    padding-right: 0;
    }

    .MuiTextField-root .MuiOutlinedInput-root {
    border-radius: 12px !important;
    }

    .PrivateNotchedOutline-legendLabelled-3>span {
    display: inline-block;
    padding-left: 5px;
    padding-right: 5px;
    }

    .gjs-cell{
    height: auto!important;
    min-height: 75px;
    }

    #ir3xk{
    top: 0!important;
    }

    .cell {
        height: auto !important;
        top: 0 !important;
    }
    .cell > div:not(.row) {
        padding: 4px 0;
    }
`;

export const CUSTOM_STYLE = [
    GoalStyle, 
    CheckboxStyle,
    ImageMuiStyle,
    FileUploadStyle,
    RadioStyle,
    SelectMuiStyle,
    tableStyle
].join('')